// /user/settings — email, name, sign-out. MFA + API tokens are V1.5.

import { signOut } from 'firebase/auth'
import { useAuthState } from 'react-firebase-hooks/auth'
import { useNavigate } from 'react-router-dom'
import { PageHeader } from '../../components/dashboard/PageHeader.jsx'
import { Button } from '../../components/ui/button.jsx'
import { auth } from '../../lib/firebase.js'

export function UserSettings() {
  const [user] = useAuthState(auth)
  const navigate = useNavigate()

  async function handleSignOut() {
    await signOut(auth)
    navigate('/', { replace: true })
  }

  return (
    <>
      <PageHeader
        breadcrumb={[{ label: 'Settings' }]}
        title="User settings"
        subhead="Your profile across Cairn"
      />
      <div className="mx-auto max-w-2xl px-6 py-8">
        <dl className="space-y-4 rounded-md border border-[var(--color-sandstone)] bg-[var(--color-limestone)] p-6">
          <div>
            <dt className="text-xs font-medium uppercase tracking-wider text-[var(--color-schist)]">
              Email
            </dt>
            <dd className="mt-1 text-sm text-[var(--color-basalt)]">{user?.email ?? '—'}</dd>
          </div>
          <div>
            <dt className="text-xs font-medium uppercase tracking-wider text-[var(--color-schist)]">
              Display name
            </dt>
            <dd className="mt-1 text-sm text-[var(--color-basalt)]">{user?.displayName ?? '—'}</dd>
          </div>
          <div>
            <dt className="text-xs font-medium uppercase tracking-wider text-[var(--color-schist)]">
              UID
            </dt>
            <dd className="mt-1 font-mono text-xs text-[var(--color-slate)]">{user?.uid ?? '—'}</dd>
          </div>
        </dl>

        <div className="mt-6">
          <Button variant="destructive" size="sm" onClick={handleSignOut}>
            Sign out
          </Button>
        </div>

        <p className="mt-6 text-xs text-[var(--color-schist)]">
          API tokens and MFA land with V1.5. Password change is handled via the Firebase reset flow
          from{' '}
          <a
            href="/auth/forgot-password"
            className="text-[var(--color-terracotta)] hover:underline"
          >
            forgot password
          </a>
          .
        </p>
      </div>
    </>
  )
}
